import type { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdIntl1T } from './pages'

type TIdToPageMapIntl1T = Record<PageIdIntl1T, TPageMapValue>

export const ID_TO_PAGE_MAP_INTL_1T: TIdToPageMapIntl1T = {
  [PageIdIntl1T.START]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/urge/StartPage').then((m) => ({
        default: m.StartPage,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/urge/StartPage'),
  },
  [PageIdIntl1T.QUESTION_1]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question1Page').then((m) => ({
        default: m.Question1Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question1Page'),
  },
  [PageIdIntl1T.QUESTION_2]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question2Page').then((m) => ({
        default: m.Question2Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question2Page'),
  },
  [PageIdIntl1T.QUESTION_3]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question3Page').then((m) => ({
        default: m.Question3Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question3Page'),
  },
  [PageIdIntl1T.QUESTION_4]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question4Page').then((m) => ({
        default: m.Question4Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question4Page'),
  },
  [PageIdIntl1T.SPEED_FEEDBACK]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/urge/SpeedFeedbackPage').then((m) => ({
        default: m.SpeedFeedbackPage,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/urge/SpeedFeedbackPage'),
  },
  [PageIdIntl1T.QUESTION_5]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question5Page').then((m) => ({
        default: m.Question5Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question5Page'),
  },
  [PageIdIntl1T.QUESTION_6]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question6Page').then((m) => ({
        default: m.Question6Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question6Page'),
  },
  [PageIdIntl1T.QUESTION_7]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question7Page').then((m) => ({
        default: m.Question7Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question7Page'),
  },
  [PageIdIntl1T.QUESTION_8]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question8Page').then((m) => ({
        default: m.Question8Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question8Page'),
  },
  [PageIdIntl1T.QUESTION_9]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question9Page').then((m) => ({
        default: m.Question9Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question9Page'),
  },
  [PageIdIntl1T.QUESTION_10]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question10Page').then((m) => ({
        default: m.Question10Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question10Page'),
  },
  [PageIdIntl1T.QUESTION_11]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question11Page').then((m) => ({
        default: m.Question11Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question11Page'),
  },
  [PageIdIntl1T.QUESTION_12]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question12Page').then((m) => ({
        default: m.Question12Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question12Page'),
  },
  [PageIdIntl1T.SMARTNESS_FEEDBACK]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/urge/SmartnessFeedbackPage').then((m) => ({
        default: m.SmartnessFeedbackPage,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/urge/SmartnessFeedbackPage'),
  },
  [PageIdIntl1T.QUESTION_13]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question13Page').then((m) => ({
        default: m.Question13Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question13Page'),
  },
  [PageIdIntl1T.QUESTION_14]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question14Page').then((m) => ({
        default: m.Question14Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question14Page'),
  },
  [PageIdIntl1T.QUESTION_15]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question15Page').then((m) => ({
        default: m.Question15Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question15Page'),
  },
  [PageIdIntl1T.QUESTION_16]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question16Page').then((m) => ({
        default: m.Question16Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question16Page'),
  },
  [PageIdIntl1T.QUESTION_17]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question17Page').then((m) => ({
        default: m.Question17Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question17Page'),
  },
  [PageIdIntl1T.QUESTION_18]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question18Page').then((m) => ({
        default: m.Question18Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question18Page'),
  },
  [PageIdIntl1T.QUESTION_19]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question19Page').then((m) => ({
        default: m.Question19Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question19Page'),
  },
  [PageIdIntl1T.QUESTION_20]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question20Page').then((m) => ({
        default: m.Question20Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question20Page'),
  },
  [PageIdIntl1T.LOGICAL_SKILLS_FEEDBACK]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/urge/LogicSkillFeedback').then((m) => ({
        default: m.LogicalSkillsFeedbackPage,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/urge/LogicSkillFeedback'),
  },
  [PageIdIntl1T.QUESTION_21]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question21Page').then((m) => ({
        default: m.Question21Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question21Page'),
  },
  [PageIdIntl1T.QUESTION_22]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question22Page').then((m) => ({
        default: m.Question22Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question22Page'),
  },
  [PageIdIntl1T.QUESTION_23]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question23Page').then((m) => ({
        default: m.Question23Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question23Page'),
  },
  [PageIdIntl1T.QUESTION_24]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question24Page').then((m) => ({
        default: m.Question24Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question24Page'),
  },
  [PageIdIntl1T.QUESTION_25]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/Question25Page').then((m) => ({
        default: m.Question25Page,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/Question25Page'),
  },
  [PageIdIntl1T.AGE_QUESTION]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/AgeQuestionPage').then((m) => ({
        default: m.AgeQuestionPage,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/questions/AgeQuestionPage'),
  },
  [PageIdIntl1T.EDUCATION_QUESTION]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/questions/EducationQuestionPage').then(
        (m) => ({
          default: m.EducationQuestionPage,
        }),
      ),
    ),
    preload: () =>
      import('cohorts/intl_1t/pages/questions/EducationQuestionPage'),
  },
  [PageIdIntl1T.DISCOVER_FEEDBACKS]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/urge/DiscoverFeedbacksPage').then((m) => ({
        default: m.DiscoverFeedbacksPage,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/urge/DiscoverFeedbacksPage'),
  },
  [PageIdIntl1T.PREPARE_FLOW]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/prepareFlow/PrepareFlow').then((m) => ({
        default: m.PrepareFlow,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdIntl1T.EMAIL]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/email/EmailPage').then((m) => ({
        default: m.EmailPage,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/email/EmailPage'),
  },
  [PageIdIntl1T.OFFER]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/offer/OfferPage').then((m) => ({
        default: m.OfferPage,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/offer/OfferPage'),
  },
  [PageIdIntl1T.PAYMENT]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/payment/PaymentPage').then((m) => ({
        default: m.PaymentPage,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/payment/PaymentPage'),
  },
  [PageIdIntl1T.REGISTRATION]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/account/AccountNove8'),
  },
  [PageIdIntl1T.NAME_ENTRY]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/name/NamePage').then((m) => ({
        default: m.NamePage,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/name/NamePage'),
  },
  [PageIdIntl1T.CERTIFICATE]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/certificate/CertificatePage').then((m) => ({
        default: m.CertificatePage,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/certificate/CertificatePage'),
  },
  [PageIdIntl1T.REPORT]: {
    Component: lazy(() =>
      import('cohorts/intl_1t/pages/report/ReportPage').then((m) => ({
        default: m.ReportPage,
      })),
    ),
    preload: () => import('cohorts/intl_1t/pages/report/ReportPage'),
  },
}
